export enum SpecLotsAndModelsTabs {
  Overview = 0,
  Options = 1
}
